import React from "react";
import { useSpring, interpolate, config } from "react-spring";
import styled from "styled-components";
import Modal from "components/UI/Modal";
import Backdrop from "components/UI/Backdrop";

const Container = styled(Backdrop)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ReferencesModal = ({title, content, onClose}) => {
  const { scale, ...style } = useSpring({
    config: config.stiff,
    from: { scale: 0, opacity: 0 },
    to: { scale: 1, opacity: 1 }
  });

  return (
    <Container>
      <Modal
        style={{
          ...style,
          transform: interpolate([scale], s => `scaleY(${s})`)
        }}
        title={
          <span>
            {title}
          </span>
        }
        content={content}
        onClose={onClose}
      />
    </Container>
  );
}

export default ReferencesModal;